// extracted by mini-css-extract-plugin
module.exports = {"buttons":"DriverForm_buttons__1FAzl","form":"DriverForm_form__3Rv-L","required":"DriverForm_required__2KfjY"};